import PropTypes from 'prop-types'
import React, { Component } from 'react'
import { connect } from 'react-redux'
import { compose, withState, withHandlers } from 'recompose'

import { requestResetPassword } from 'data/auth/actions'
import { selectors as ConfigSelectors } from 'data/config'
import RoutesHelper from '../../helpers/RoutesHelper'
import history from 'browserHistory'
import { Input } from 'components/Utils/Form'
import { Text, Button } from 'components/base'
import BackToSignin from './BackToSignin'

class AuthRequestResetPassword extends Component {
  static propTypes = {
    email: PropTypes.string.isRequired,
    setEmail: PropTypes.func.isRequired,
    requestResetPassword: PropTypes.func.isRequired,
  }

  onResetPassword = event => {
    event.preventDefault()
    const { requestResetPassword, email } = this.props
    requestResetPassword({ email })
  }

  render() {
    const { setEmail, previousLocation } = this.props
    return (
      <div className="height-full flexbox-grow flexbox flexbox-column">
        <div className="flexbox-grow flexbox flexbox-align-center scroll-y">
          <form
            className="flexbox flexbox-column width-full"
            onSubmit={this.onResetPassword}
          >
            <div className="margin-bottom-large">
              <BackToSignin
                onClick={() =>
                  history.replace(previousLocation || RoutesHelper.login())
                }
              />
            </div>
            <Text.Title className="margin-bottom-small center-text">
              Reset your password
            </Text.Title>
            <Text.Corpus className="margin-vertical-normal">
              Enter the email address you used to sign up to Slite and we'll
              send you instructions to reset your password.
            </Text.Corpus>
            <Input
              id="email"
              className="margin-bottom-small"
              type="email"
              onChange={setEmail}
              placeholder="eg: john.doe@acme.inc"
              tabIndex="1"
            />
            <Button.Primary tabIndex="2" type="submit">
              Reset my password
            </Button.Primary>
          </form>
        </div>
      </div>
    )
  }
}

const mapStateToProps = state => ({
  boardingAppRoot: ConfigSelectors.getBoardingAppRoot(state),
  previousLocation: state.ui.previousLocation,
})

export default compose(
  withState('email', 'setEmail', ''),
  withHandlers({
    setEmail: ({ setEmail }) => event => setEmail(event.target.value),
  }),
  connect(
    mapStateToProps,
    { requestResetPassword }
  )
)(AuthRequestResetPassword)
